<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader d-flex">
        <div class="d-flex align-items-center">
          <div class="mr-4">
            <button class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls"
                    @click="clearSelectedCategory">{{$t('Back')}}
            </button>
          </div>
          <h1 class="m-subheader__title m-subheader__title--separator">
            {{ categoryName }}
          </h1>
        </div>
        <input class="form-control mr-3 max-width-215 rewards-search-bar" type="text" placeholder="Znajdź" v-model="nameFilter">
      </div>
      <div class="m-content" v-if="!rewards.length">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                {{$t('No rewards')}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="rewardsSliced.length > 0" class="m-content">
        <div class="row">
          <reward-grid-item v-for="reward in rewardsSliced" :reward="reward" :key="reward.id"></reward-grid-item>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">{{$t('Load more')}}
            </button>
          </div>
        </div>
      </div>
      <div v-else class="m-content text-center">
        <spinner v-if="isLoading"></spinner>
      </div>
    </div>
    <order-reward-modal></order-reward-modal>
    <order-digital-reward-modal></order-digital-reward-modal>
    <digital-reward-modal/>
    <material-reward-modal/>
    <variants-reward-modal/>
  </page>
</template>

<script>
import RewardGridItem from "../reward/RewardGridItem";
import Page from "./Page";
import {mapActions, mapState} from 'vuex';
import ClickOutside from 'vue-click-outside'
import Encode from "@/directives/encode";
import Spinner from "../spinner/Spinner";
import OrderRewardModal from "../modal/OrderRewardModal";
import OrderDigitalRewardModal from "../modal/OrderDigitalRewardModal";
import BeforeRoute from "@/mixins/beforeRoute";
import PageTitle from "@/mixins/pageTitle";
import DigitalRewardModal from "@/components/modal/DigitalRewardModal";
import MaterialRewardModal from "@/components/modal/MaterialRewardModal";
import VariantsRewardModal from "../modal/VariantsRewardModal";

export default {
  name: "RewardsByCategoryPage",
  components: {
    MaterialRewardModal,
    VariantsRewardModal,
    DigitalRewardModal,
    OrderDigitalRewardModal,
    OrderRewardModal,
    Spinner,
    Page,
    RewardGridItem
  },
  directives: {
    ClickOutside,
    Encode
  },
  mixins: [
    BeforeRoute('fetchEntityByCategoryHidRewards'),
    PageTitle('Nagrody'),
  ],
  data() {
    return {
      SORTING_DATE_ADD_ASC: 0,
      SORTING_DATE_ADD_DESC: 1,
      SORTING_MISSING_POINTS_ASC: 2,
      SORTING_MISSING_POINTS_DESC: 3,
      SORTING_REQUIRED_POINTS_ASC: 4,
      SORTING_REQUIRED_POINTS_DESC: 5,
      SORTING_NAME_ASC: 6,
      SORTING_NAME_DESC: 7,
      SORTING_POSITION_ASC: 8,
      SORTING_POSITION_DESC: 9,
      categoryDropdownOpen: false,
      nameFilter: '',
      variant_of: [],
      showOnPage: 0,
      isLoading: false,
      category: 0,
    }
  },
  mounted() {
    this.fetchSettings(this.entityUuid).then(() => {
      this.resetShowOnPage()
      this.category = this.categories[0].id;
    });
  },
  methods: {
    ...mapActions([
      'fetchEntityByCategoryHidRewards',
      'fetchSettings',
    ]),
    sortAsc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return 1;

      if (a < b)
        return -1;

      return 0;
    },
    sortDesc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return -1;

      if (a < b)
        return 1;

      return 0;
    },
    sortPositionAsc(a, b) {
      let aPos = a.position;
      let bPos = b.position;

      if (null !== aPos) {
        aPos = parseInt(aPos);
      }

      if (null !== bPos) {
        bPos = parseInt(bPos);
      }

      if (aPos === bPos) {
        return a.name.localeCompare(b.name);
      }

      if (aPos === null) {
        return 1;
      }

      if (bPos === null) {
        return -1;
      }

      return this.sortAsc(aPos, bPos);
    },
    sortPositionDesc(a, b) {
      let aPos = a.position;
      let bPos = b.position;

      if (null !== aPos) {
        aPos = parseInt(aPos);
      }

      if (null !== bPos) {
        bPos = parseInt(bPos);
      }

      if (aPos === bPos) {
        return a.name.localeCompare(b.name);
      }

      if (aPos === null) {
        return 1;
      }

      if (bPos === null) {
        return -1;
      }

      return this.sortDesc(aPos, bPos);
    },
    showMore() {
      this.showOnPage = this.showOnPage + this.rewardsPerPage;
    },
    resetShowOnPage() {
      this.showOnPage = this.rewardsPerPage;
    },
    clearSelectedCategory() {
      this.isDetailsModalOpen = false;
      let push = { name: 'RewardsPage' };

      if (this.returnPage) {
        push.query = {
          return: this.returnPage,
          status: this.returnStatus,
          showOnPage: this.returnShowOnPage
        };
      }
      this.$router.push(push)
    }
  },
  computed: {
    ...mapState({
      rewards: state => state.entityRewards.rewards,
      categories: state => state.entityRewards.categories,
      saldo: state => state.auth.user.saldo,
      entityUuid: state => state.auth.entity.uuid,
      sorting: state => state.settings.rewardsCatalogSort,
      rewardsShowVariants: state => state.settings.rewardsShowVariants,
      rewardsPerPage: state => state.settings.rewardsPerPage,
      rewardsCategoriesAsGrid: state => state.settings.rewardsCategoriesAsGrid,
    }),
    rewardsFiltered() {
      let filtered = [];

      if (this.nameFilter.length) {
        this.resetShowOnPage();
        filtered = this.rewards.filter((r) => r.name.trim().toLowerCase().includes(this.nameFilter.trim().toLowerCase()))
      } else {
        filtered = this.rewards;
      }
      filtered = filtered.filter((r) => r.type!=="2" || r.variants.length>0);

      if (!this.rewardsShowVariants) {
        filtered = filtered.filter((r) => r.variant_of.length<1);
      }

      return filtered;
    },
    rewardsSorted() {
      let cloneDeep = require('lodash.clonedeep');
      let cloneFiltered = cloneDeep(this.rewardsFiltered);

      switch (this.sorting) {
        case this.SORTING_DATE_ADD_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.id, b.id, true));
        case this.SORTING_DATE_ADD_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.id, b.id, true));
        case this.SORTING_MISSING_POINTS_ASC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortAsc(aMissing, bMissing)
          });
        case this.SORTING_MISSING_POINTS_DESC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortDesc(aMissing, bMissing)
          });
        case this.SORTING_REQUIRED_POINTS_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.points, b.points, true));
        case this.SORTING_REQUIRED_POINTS_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.points, b.points, true));
        case this.SORTING_NAME_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.name, b.name));
        case this.SORTING_NAME_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.name, b.name));
        case this.SORTING_POSITION_ASC:
          return cloneFiltered.sort((a, b) => this.sortPositionAsc(a, b));
        case this.SORTING_POSITION_DESC:
          return cloneFiltered.sort((a, b) => this.sortPositionDesc(a, b));
      }
    },
    rewardsSliced() {
      return this.rewardsSorted.slice(0, this.showOnPage)
    },
    isThereMore() {
      return this.showOnPage < this.rewardsSorted.length;
    },
    categoryName() {
      let category = this.categories[0];
      return category
          ? category.name
          : null;
    },
  },
}
</script>

<style scoped>
.m-nav .m-nav__item-ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-text {
  color: var(--accent-color) !important;
}

.width-315 {
  width: 315px !important;
}

.max-width-215 {
  max-width: 215px;
}

@media (max-width: 400px) {
  .m-subheader .m-subheader__title {
    font-size: 2.2rem;
  }
  .mr-4 {
    margin-right: 1.2rem !important;
  }
  .d-flex {
    display: block !important;
  }
  .m-subheader__title.m-subheader__title--separator {
    margin-top: .7rem;
  }
  .rewards-search-bar {
    margin-top: .7rem;
  }
  .rewards-search-bar.max-width-215 {
    max-width: 100%;
  }
}
</style>
